import { Keys, ShortcutKeys, IShortcutDescriptor, IShortcutDescriptorGroup } from "@pjs/core-ui";
import { KeystrokeInfoCategory } from "@pebblepad/ckeditor";
import { richTextI18n } from "../../../i18n/RichTextI18n.const";
import { shortcutKeysExcludeList } from "../ShortcutKeysExcludeList.const";

export const mapEditorKeysToShortcut = (keys: Map<string, KeystrokeInfoCategory>): IShortcutDescriptorGroup => {
    const newGroup: IShortcutDescriptorGroup = {
        description: richTextI18n.getString("editor_usv.shortcut_keys_group"),
        shortcuts: []
    };

    for (const category of keys.values()) {
        for (const group of category.groups.values()) {
            for (const keyStroke of group.keystrokes) {
                if (typeof keyStroke.keystroke === "string") {
                    if (!isKeyExcluded(keyStroke.keystroke)) {
                        const shortCut: IShortcutDescriptor = {
                            keys: createKeys(keyStroke.keystroke),
                            description: keyStroke.label
                        };

                        newGroup.shortcuts.push(shortCut);
                    }

                    continue;
                }

                processKeystrokeArray(
                    newGroup,
                    keyStroke.label,
                    keyStroke.keystroke.flatMap((keystroke) => keystroke)
                );
            }
        }
    }

    return newGroup;
};

const processKeystrokeArray = (newGroup: IShortcutDescriptorGroup, label: string, keystrokes: Array<string>): void => {
    if (!isKeyExcluded(keystrokes[0])) {
        const shortCut: IShortcutDescriptor = {
            keys: createKeys(keystrokes[0]),
            description: label
        };

        newGroup.shortcuts.push(shortCut);
    }

    keystrokes.splice(0, 1);

    for (const combo of keystrokes) {
        if (!isKeyExcluded(combo)) {
            const shortCut: IShortcutDescriptor = {
                keys: createKeys(combo),
                description: richTextI18n.getString("editor_usv.alternate_key_combo", { label: label })
            };

            newGroup.shortcuts.push(shortCut);
        }
    }
};

const createKeys = (keystroke: string): ShortcutKeys => {
    const parts = keystroke.split("+");
    const shortcut: Array<string> = [];

    for (const part of parts) {
        if (part.toLowerCase() === "ctrl") {
            shortcut.push(navigator.userAgent.includes("Mac") ? richTextI18n.getString("editor_usv.command") : richTextI18n.getString("editor_usv.control"));
        } else if (part.toLowerCase() === "shift") {
            shortcut.push(Keys.Shift.toLowerCase());
        } else {
            shortcut.push(part.toLowerCase());
        }
    }

    return shortcut as ShortcutKeys;
};

const isKeyExcluded = (key: string): boolean => {
    return shortcutKeysExcludeList.includes(key.toLowerCase());
};
